export { PromoBadge } from './PromoBadge'
